// store.js

import { writable } from 'svelte/store';

export const usuario = writable('');

export const filtro_cate = writable('TODOS');
export const filtro_size = writable("''");
export const orden_dir = writable('desc');
export const orden_por = writable('touched');
export const filtro_page = writable(0);
export const view_type = writable('grid');
export const filtro_buscar = writable('');

